export interface DatiqRGB {
    r: number;
    g: number;
    b: number;
}
export const FONT_FAMILY = 'Sequel Sans, Helvetica, Arial, Sans-Serif';
export const DATIQ_PRIMARY_COLOR = '#0046e0';
export const DEFAULT_LIGHT_OPACITY = 0.9;
export const DEFAULT_OPACITY = 0.5;
export const DEFAULT_HEAVY_OPACITY = 0.1;
export const getRGBFromHex: (hexcolor: string) => DatiqRGB = (
    hexcolor: string
): DatiqRGB => {
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }

    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);

    return { r, g, b };
};
export const getDatiqContrast: (hexcolor: string) => string = (
    hexcolor: string
) => {
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }

    const { r, g, b } = getRGBFromHex(hexcolor);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= 128 ? 'black' : 'white';
};
export const setRGBAFromHex: (hexcolor: string, alpha: number) => string = (
    hexcolor: string,
    alpha: number
): string => {
    const { r, g, b } = getRGBFromHex(hexcolor);

    return `rgba(${r},${g},${b},${alpha})`;
};
export const DEFAULT_POSITIVE_COLOR = '#00e107';
export const DEFAULT_NEGATIVE_COLOR = '#e10600';
export const DEFAULT_NEUTRAL_COLOR = 'black';
export const DEFAULT_UP_ARROW = 'app:arrow-drop-up';
export const DEFAULT_DOWN_ARROW = 'app:arrow-drop-down';
export const EXPANDABLE_ICON = 'fullscreen';
export const COLLABSABLE_ICON = 'fullscreen_exit';
export const DRAWER_ICON = 'tune';
export const GRID_GAP_X = 48;
export const GRID_GAP_Y = 24;
